import React from 'react';
import { number } from 'prop-types';
import { Checkbox } from '@one-thd/sui-atomic-components';
import { ListTilePlaceholder } from '@thd-olt-component-react/list-tile';

export const MiniListsSummaryPlaceholder = ({ numberPlaceholders }) => {
  const placeholders = Array.from(Array(numberPlaceholders));

  return (
    <div className='sui-flex sui-flex-col sui-w-full sui-gap-7' data-testid="lists-placeholder">
      {
        placeholders.map((__, index) => (
          <div key={`min-list-summary-placeholder-${index}`}
               className="sui-flex sui-gap-3 sui-items-center"
               data-component="ListTilePlaceholder"
          >
            <Checkbox />
            <ListTilePlaceholder numberOfThumbnails={4} />
          </div>

        ))
      }
    </div>
  );
};

MiniListsSummaryPlaceholder.propTypes = {
  numberPlaceholders: number.isRequired,
};
